<template>
  <PageLoader v-if="isLoading" />
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-end">
        <Button btn-class="btn-sm" type="new" @click="addEstate" btn-text="projects.estates.add"></Button>
      </div>
      <div class="row" v-if="estates?.length > 0">
        <EstateCard v-for="(estate, key) in estates" :key="key" :estate="estate" @load="setLoader"/>
      </div>
      <div v-else class="text-center">
        <div class="pt-8">
          <Img filename="empty.png" alt="" class="mw-100 h-125px h-sm-175px" />
        </div>
        <h2 class="fs-2x fw-bolder mb-0">{{ $t('projects.estates.no_data_found') }}</h2>
        <br>
      </div>
    </div>
  </div>

  <CreateEstate id="estate_add_modal" @load="setLoader"/>
</template>

<script setup> 
  import {computed, onMounted, ref, watch} from "vue";
  import {useStore} from "vuex";
  import Button from "@/components/Button";
  import EstateCard from "@/Modules/Projects/components/EstateCard.vue";
  import CreateEstate from "./modals/CreateOrUpdateEstate.vue";
  import { useRoute } from "vue-router";
  import Img from "@/components/Img.vue";
  import PageLoader from "@/components/PageLoader.vue";

  const store = useStore()
  const route = useRoute()

  const estates = computed(() => store.getters['projects/getProjectEstates'])

  const isLoading = ref(true)

  function addEstate() {
    $('#estate_add_modal').modal('toggle')
  }

  function setLoader(){
    isLoading.value = true
    loadData()
  }

  function loadData() {
    store.dispatch('projects/loadProjectEstates', route.params.id)
        .then(() => {})
        .finally(() => isLoading.value = false)
  }

  onMounted(() => {
    loadData()
  })
</script>
<style scoped>
.back{
  background-color: var(--bs-light-primary);
  border-radius: 8px;
  padding: 10px;
  width: auto;
}
</style>